import React from 'react';
import PropTypes from 'prop-types';

class LogoCard extends React.PureComponent {
    render() {
        const { container_class, image_class, image_src, title, title_class, description, description_class } = this.props;

        return (
            <div className={container_class}>
                <div className="ori-pad-15 ori-b-mrgn-10 ori-flex-row ori-flex-jc">
                    <img src={image_src} alt="" className={`ori-animated ori-zoom-in ${image_class}`} />
                </div>
                {
                    title &&
                    <p className={title_class}>{title}</p>
                }
                {
                    description &&
                    <p className={description_class}>{description}</p>
                }
            </div>
        );
    }
}

LogoCard.propTypes = {
    container_class: PropTypes.string,
    image_class: PropTypes.string,
    image_src: PropTypes.string,
    title: PropTypes.string,
    title_class: PropTypes.string,
    description: PropTypes.string,
    description_class: PropTypes.string,
};

LogoCard.defaultProps = {
    container_class: "ori-pad-10 ori-text-center",
    image_class: "ori-height-50",
    disabled: false,
};

export default LogoCard;


// WEBPACK FOOTER //
// ./src/components/logocard/index.js